import { styled } from '@mui/system';
import { Paper, Button } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  maxWidth: '700px',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: theme.spacing(-2)
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2)
  }
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: '#EEE',
  padding: theme.spacing(),
  zIndex: '2',
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));
